import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import axios, { API, authHeaders, formatError } from "../../lib/api";

const Row = ({ row, onSaved }) => {
  const [val, setVal] = useState(row.output_t ?? "");
  const [busy, setBusy] = useState(false);
  const label = new Date(`${row.date}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.put(`${API}/admin/production-log/${row.date}`, { output_t: Number(val) }, { headers: authHeaders() });
      toast.success(`${label}: ${val} t saved`);
      onSaved();
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form data-testid={`admin-log-row-${row.date}`} onSubmit={save} className="flex items-center gap-3 border-t hairline py-3">
      <span className="w-24 sm:w-32 shrink-0 text-sm">{label}</span>
      <Input data-testid={`admin-log-input-${row.date}`} type="number" step="0.1" min="0" required placeholder="—" value={val} onChange={(e) => setVal(e.target.value)} className="h-10 min-w-[96px] flex-1 sm:flex-none sm:w-[160px]" />
      <span className="text-sm text-[var(--sage)]">t</span>
      <button data-testid={`admin-log-save-${row.date}`} disabled={busy} className="sm:ml-auto h-10 px-4 sm:px-5 shrink-0 rounded-full border hairline text-sm font-semibold hover:bg-white/5 disabled:opacity-50">Save</button>
    </form>
  );
};

export const ProductionLog = ({ onSaved }) => {
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/production-log`, { headers: authHeaders() });
      setRows(Array.isArray(data) ? data : []);
    } catch (err) {
      toast.error(formatError(err));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const saved = () => { load(); onSaved(); };

  return (
    <div data-testid="admin-production-log" className="mt-5 rounded-[24px] border hairline bg-[var(--forest-2)] p-6 sm:p-8">
      <p className="font-display text-2xl font-semibold">Past days</p>
      <p className="text-sm text-[var(--sage)] mb-3">Enter or correct output for the last 14 days. The public chart shows the latest 7 days with entries. Saving today also updates today's output.</p>
      {[...rows].reverse().map((r) => <Row key={`${r.date}-${r.output_t}`} row={r} onSaved={saved} />)}
    </div>
  );
};
